
export interface venuesetting {
    name: string,
    value: string,
}

export class cVenuesetting implements venuesetting {
    name: string;
    value: string;
}